export const isUnlockedByRoleOrFreeGames = (roleEnabled?: boolean, segmentHasFreeGames?: boolean) => !!roleEnabled || !!segmentHasFreeGames
